<template>
  <div v-if="!readOnly && !field.readOnly">
    <div class="input-group">
      <label>{{ field.label }} {{ field.required ? '*' : '' }}</label>
    </div>
    <v-radio-group ref="inputRef"
                   v-model="fieldValue"
                   :disabled="field.disabled"
                   :class="field.class"
                   class="pt-2"
                   @change="fieldChanged">
      <v-row>
        <v-col v-for="(item, index) in fieldItems" :key="index" :class="field.row ? 'xs6 sm4 md3 lg3' : 'xs12'">
          <v-radio :label="item[field.itemText] || item" :value="item[field.itemValue] || item" />
        </v-col>
      </v-row>
    </v-radio-group>
    <p v-if="field.hint" class="grey--text mb-0">
      {{ field.hint }}
    </p>
  </div>
  <div v-else :class="{'reg-information': !small, 'reg-information-small': small}">
    <label>{{ field.label }}</label>
    <p>{{ fieldValue }}</p>
  </div>
</template>

<script>
import { defineComponent, computed, getCurrentInstance, toRef } from 'vue'
import { useDynamicField } from '../composables/useDynamicField'

export default defineComponent({
  name: 'DynamicRadioGroup',
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    field: {
      type: Object,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    box: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    isValidating: {
      type: Boolean,
      default: false
    },
    itemKey: {
      type: String,
      default: ''
    }
  },
  emits: ['input', 'change'],
  setup(props, { emit, expose }) {
    const instance = getCurrentInstance()
    const $store = instance.proxy.$store

    const {
      fieldValue,
      inputRef,
      fieldChanged,
      hasError
    } = useDynamicField({
      value: toRef(props, 'value'),
      field: props.field,
      readOnly: props.readOnly,
      isValidating: toRef(props, 'isValidating'),
      itemKey: props.itemKey,
      emptyValue: undefined,
      emit
    })

    const fieldItems = computed(() => {
      if (props.field.items) {
        return props.field.items
      } else if (props.field.dataSource && props.field.dataSource.modelName) {
        return $store.state[props.field.dataSource.state || 'dynamicModule'][props.field.dataSource.modelName]
      }
      return []
    })

    // Expose properties for DynamicForm validation
    expose({
      hasError,
      validate: () => inputRef.value?.validate?.()
    })

    return {
      fieldValue,
      inputRef,
      fieldChanged,
      fieldItems
    }
  }
})
</script>

<style lang="scss">
</style>